// extracted by mini-css-extract-plugin
export default {"root":"IconArrow_root__3TodM","angle45":"IconArrow_angle45__YGZap","right":"IconArrow_right__ZCICK","disabled":"IconArrow_disabled__PR22K"};